import axios from 'public/helpers/MyAxios';
import Config from 'public/constants/Config';

const service = {
  fetchOne: (id, expand = '') => axios.get(`${Config.baseUrl}/coordinator/online-survey/questionnaire?id=${id}${expand ? '&' : ''}${expand}`),
};

export default service;
